import React, { Fragment, useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import Modal from '../../common/Modal'
import styles from './AppointmentStatusButton.module.scss'

export default function AppointmentStatusButton() {
  const [isOpen, setIsOpen] = useState(false)
  const [data, setData] = useState({})

  function onClick() {
    setIsOpen((prev) => !prev)
  }

  useEffect(() => {
    axios.get('/admin/appointments/breakdown_per_day').then((res) => setData(res.data))
  }, [])

  const markup = useMemo(() => {
    const sortedSchoolNames = Object.keys(data).sort()

    return sortedSchoolNames.map((schoolName) => {
      const schoolData = data[schoolName]

      const sortedSchoolData = Object.keys(schoolData).sort()
      const hasNoData = Object.values(schoolData).flat().filter((obj) => Object.keys(obj).length > 0).length === 0

      if (hasNoData) return null

      const schoolMarkup = sortedSchoolData.map((date) => {
        const packageInfo = schoolData[date]
        const sortedPackages = Object.keys(packageInfo).sort()

        if (sortedPackages.length === 0) return null

        return (
          <tr key={date}>
            <td>{date}</td>
            {sortedPackages.map((packageName) => (
              <td colSpan={1} key={packageName}>
                {packageName}
                <br />
                {packageInfo[packageName]}
              </td>
            ))}
          </tr>
        )
      })

      return (
        <Fragment key={schoolName}>
          <tr>
            <td>
              {schoolName}
            </td>
          </tr>
          {schoolMarkup}
        </Fragment>
      )
    })
  }, [Object.keys(data).length])

  return (
    <>
      <button onClick={onClick} type="button">Show Appointments Per Day</button>
      <Modal className={styles.modalClass} modalIsOpen={isOpen} closeModal={() => setIsOpen(false)}>
        <table className={styles.table}>
          <tbody>
            {markup}
          </tbody>
        </table>
      </Modal>
    </>
  );
}
